import { withTranslation } from "next-i18next";
import Cookies from "js-cookie";
import { useRouter } from "next/compat/router";
import Dropdown from "react-bootstrap/Dropdown";
import { DropdownButton } from "react-bootstrap";
import classNames from "classnames";
import Image from "../Image";
import IconSvg from "../IconSvg";

function LanguageSelector({ className, t }) {
  const router = useRouter();

  const localesAvailable = process.env.NEXT_PUBLIC_LOCALES_AVAILABLE.split(",");
  const currentLanguage = router?.locale ?? "fr";
  const localesToDisplayOnDropdownMenu = localesAvailable.filter(
    (locale) => locale !== currentLanguage,
  );

  function getLocaleDetails(locale) {
    let languageName, countryFlag;

    switch (locale) {
      case "fr":
        languageName = t("common:language_selector.french");
        countryFlag = "franceFlag";
        break;
      case "de":
        languageName = t("common:language_selector.german");
        countryFlag = "germanyFlag";
        break;
      case "nl":
        languageName = t("common:language_selector.dutch");
        countryFlag = "netherlandsFlag";
        break;
      case "en":
        languageName = t("common:language_selector.english");
        countryFlag = "unitedKingdomFlag";
        break;
      default:
        languageName = t("common:language_selector.french");
        countryFlag = "franceFlag";
    }

    return { languageName, countryFlag };
  }

  function setLanguage(newLanguage) {
    Cookies.set("NEXT_LOCALE", newLanguage, { expires: 3650 });

    const { pathname, asPath, query } = router;
    router.push({ pathname, query }, asPath, { locale: newLanguage });
  }

  function displayLanguage(locale, withChevron = false) {
    const { languageName, countryFlag } = getLocaleDetails(locale);

    return (
      <div className="d-flex align-items-center justify-content-start gap-1 text-dark">
        <Image
          src={countryFlag}
          alt={countryFlag}
        />
        <p className="mb-0 font-size-sm">{languageName}</p>
        {withChevron && (
          <span style={{ height: "16px", width: "16px", stroke: "currentColor" }}>
            <IconSvg name="chevron-down" />
          </span>
        )}
      </div>
    );
  }

  if (localesAvailable.length <= 1) return <div />;

  return (
    <section className="d-flex align-items-center justify-content-center gap-2">
      <p className="mb-0 font-size-sm">{t("common:language_selector.site_language")}</p>
      <div className={classNames("language-selector-container", className)}>
        <Dropdown>
          <DropdownButton
            title={displayLanguage(currentLanguage, true)}
            variant="transparent"
            id="dropdown-basic"
          >
            {localesToDisplayOnDropdownMenu.map((locale) => (
              <Dropdown.Item
                key={locale}
                as="button"
                onClick={() => setLanguage(locale)}
              >
                {displayLanguage(locale)}
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </Dropdown>
      </div>
    </section>
  );
}

export default withTranslation("common")(LanguageSelector);
